import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogProps,
  Stack,
  Typography
} from '@mui/material';
import {
  ReactElement,
  ReactNode
} from 'react';

import { Close } from '@mui/icons-material';



export type BasicDialogLayoutProps = {
  isVisible: boolean | false;
  handleClose: () => void;
  handleSubmit?: () => void;
  onDelete?: () => void;
  formTitle: ReactNode;
  subTitle?: ReactNode;
  titleIcon?: ReactElement | undefined;
  children: ReactNode | ReactNode[];
  saveText?: string;
  closeButton?: ReactNode;
};

export const FC = (props: BasicDialogLayoutProps & Partial<DialogProps>) => {
  return (
    <Dialog
      fullScreen={props.fullScreen ?? false}
      open={props.isVisible}
      onClose={() => props.handleClose()}
    >
      <DialogContent>
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
        >
          <Box
            display='flex'
            flexDirection='column'
            justifyContent='stretch'
            height='100%'
            minWidth='30rem'
          >
            {/* MODAL HEADER SECTION  */}
            <Box sx={{
              display: 'flex',
              flexDirection: 'column'
            }}
            >
              <Box sx={{
                pl: 3,
                pb: 2
              }}
              >
                {props.titleIcon}
              </Box>

              <Box
                paddingBottom='1.5rem'
                paddingX='1.5rem'
              >
                <Box
                  display='flex'
                  paddingBottom='1rem'
                  flexDirection='row'
                  alignItems='center'
                  justifyContent='space-between'
                >
                  <Typography
                    flex='1 1 0'
                    variant='modalSummaryPaneTitle'
                  >
                    {props.formTitle ?? 'Form title'}
                  </Typography>

                </Box>

                <Typography
                  color='#A0A0A1'
                  variant='activitySubHeaderPrimary'
                >
                  {props.subTitle}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box sx={{
          }}
          >
            {props.closeButton}
          </Box>
        </Box>

        {/* PRIMARY CONTENT SECTION */}

        <Box
          component='form'
          paddingX='1.5rem'
          onSubmit={(e) => {
            e.preventDefault();
            if (props.handleSubmit) {
              props.handleSubmit();
            }
          }}
        >

          {props.children}

          <Box
            sx={{
              borderTop: '1px solid #A0A0A1',
              mt: '1rem'
            }}
          >
            <Stack
              direction='row'
              paddingTop='1rem'
              justifyContent='space-between'
              columnGap={1}
              sx={{
                '@media print': {
                  display: 'none'
                }
              }}
            >
              {props.onDelete && (
                <Box flex={1}>
                  <Button
                    variant='contained'
                    color='error'
                    onClick={props.onDelete}
                    fullWidth
                    startIcon={<Close />}
                  >
                    Delete
                  </Button>
                </Box>
              )}

              <Box
                flex={2}
              >
                <Button
                  startIcon={<Close />}
                  variant='contained'
                  color='secondary'
                  fullWidth
                  onClick={() => {
                    props.handleClose();
                  }}
                >
                  Cancel
                </Button>
              </Box>

              <Box flex={2}>
                <Button
                  variant='contained'
                  color='primary'
                  fullWidth
                  type='submit'
                  disabled={!props.handleSubmit}
                >
                  {props.saveText ?? 'Save'}
                </Button>
              </Box>

            </Stack>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
